import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactModal, ContentSection, FlatGallery, Footer, GridGallery, Header } from './components';
import { Button, PriceCard, Section } from './ui';
import { useTranslatedData } from './hooks';

import './App.css';

function App() {
  const { t } = useTranslation();
  const { marketPlace, pricing, useCases, whyWe } = useTranslatedData();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME || 'TrendVision';

    if(process.env.NODE_ENV === 'production') {
        console.warn = console.error = console.log = () => {};
    }
  }, []);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  return (
      <div className="App">
          <Header />
          <main className="App-main">
              <section className="Research-section">
                  <h1 className="Research-title">{t('main.hero.title')}</h1>
                  <h2 className="Research-subtitle">{t('main.hero.subtitle')}</h2>
                  <Button onClick={handleOpenModal}>{t('main.hero.demoButton')}</Button>
                  <div className="Research-image" />
              </section>
              <Section id="research" title={t('main.research.title')} className="Marketplace-section">
                  <span className="Section-subtitle Marketplace-subtitle">
                      {t('main.research.subtitle')}
                  </span>
                  <ContentSection items={marketPlace} onClick={handleOpenModal} />
              </Section>
              <Section id="cases" title={t('main.cases.title')} className="Cases-section">
                  <span className="Section-subtitle">
                      {t('main.cases.subtitle')}
                  </span>
                  <FlatGallery items={useCases} />
              </Section>
              <Section id="why" title={t('main.why.title')} className="Cases-section">
                  <span className="Section-subtitle" dangerouslySetInnerHTML={{ __html: t('main.why.subtitle') }} />
                  <GridGallery items={whyWe} />
              </Section>
              <Section id="prices" title={t('main.prices.title')} className="Prices-section">
                  <span className="Section-subtitle Prices-subtitle" dangerouslySetInnerHTML={{ __html: t('main.prices.subtitle') }} />
                  <div className="Prices-content">
                      {pricing.map((item, index) => <PriceCard {...item} key={item.key} cardIndex={index} onClick={handleOpenModal} />)}
                  </div>
              </Section>
              <Section id="trial" title={t('main.trial.title')} className="Cases-section">
                  <span className="Section-subtitle">
                      {t('main.trial.subtitle')}
                  </span>
                  <Button onClick={handleOpenModal}>{t('main.hero.demoButton')}</Button>
              </Section>
          </main>
          <Footer />
          <ContactModal isOpen={isModalOpen} onClose={handleCloseModal} />
      </div>
  );
}

export default App;
